"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizeToBytes = void 0;
/**
 * Converts string representation of file size
 * in to a number
 */
function sizeToBytes(size) {
    if (typeof size === 'number') {
        return size;
    }
    var units = [['bytes', 'b'], 'kb', 'mb', 'gb', 'tb', 'pb'];
    var unit = size.replace(/[0-9.]/g, '').toLowerCase().replace(/\s/g, '');
    var power = units.findIndex(function (item) { return Array.isArray(item) ? item.includes(unit) : item === unit; });
    return power === -1
        ? 0
        : (parseFloat(size) || 0) * Math.pow(1024, power);
}
exports.sizeToBytes = sizeToBytes;
